import Reveal from "../components/Reveal";
import Evolution from "../components/Evolution";
import { scrollToId } from "../lib/scroll";
import { useLang } from "../i18n/i18n";

export default function Infos() {
  const { t } = useLang();
  const METHODS = [
    { n: "01", tt: "infos.m1t", dd: "infos.m1d" },
    { n: "02", tt: "infos.m2t", dd: "infos.m2d" },
    { n: "03", tt: "infos.m3t", dd: "infos.m3d" },
    { n: "04", tt: "infos.m4t", dd: "infos.m4d" },
  ];

  return (
    <main className="pt-[72px]">
      <section className="mx-auto max-w-7xl px-5 sm:px-8 py-20" data-testid="infos-header">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase text-gold">{t("infos.eyebrow")}</p>
          <h1 className="mt-4 font-display text-5xl sm:text-7xl font-light text-cream">
            {t("infos.title1")} <em className="gold-text italic font-medium">{t("infos.title2")}</em>
          </h1>
        </Reveal>
      </section>

      <section className="mx-auto max-w-7xl px-5 sm:px-8 pb-24" data-testid="methods-section">
        <div className="grid gap-5 md:grid-cols-2">
          {METHODS.map((m, i) => (
            <Reveal key={m.n} delay={0.06 * i} className="h-full">
              <div className="h-full rounded-2xl border border-gold/15 bg-panel/70 p-8 transition-all hover:border-gold/40 hover:-translate-y-1 duration-300">
                <span className="font-display text-4xl text-gold/40 tabular">{m.n}</span>
                <h3 className="mt-4 font-display text-xl text-cream">{t(m.tt)}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-cream/60">{t(m.dd)}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <Evolution />

      <section className="mx-auto max-w-7xl px-5 sm:px-8 py-20 text-center">
        <Reveal>
          <h2 className="font-display text-3xl sm:text-5xl font-light text-cream">{t("infos.ready")}</h2>
          <button
            onClick={() => scrollToId("calculateur")}
            data-testid="infos-cta-calculator"
            className="mt-8 rounded-full bg-gold px-9 py-4 text-sm font-semibold text-ink transition-all hover:bg-goldlight hover:shadow-[0_0_36px_rgba(212,175,55,0.4)]"
          >
            {t("infos.cta")}
          </button>
        </Reveal>
      </section>
    </main>
  );
}
